import React, { useState } from "react";
import styles from "./CreateProduct.module.sass";
import Card from "../../../components/Card";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import Modal from "../../../components/Modal";
import Body from "./body";
import { UseApi } from "../../../hooks/use-api";
import { CreateNftTemplate } from "../../../Services/lib/nft";
import cn from "classnames";
import Loader from "../../../components/Loader";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import Confirm from "../../../components/Confirm";
import TemplateModal from "../../NewProduct/TemplateModal";
import { useUser } from "../../../context";
import product from "../../../i11/Product";
import RichEditor from "../../../components/HTMLeditor/DraftEditor";
import RichViewer from "../../../components/HTMLeditor/Draft.viewer";

const optionsPurchase = ["Unique", "Standard", "Auction"];

const options = {
	Unique: "SINGLE_EDITION",
	Standard: "LIMITED_EDITION",
	Auction: "AUCTION_EDITION",
};

const isFalse = (element) => element === false;

const getIsValidPacakage = (criterias) =>
	Object.values(criterias).some(isFalse);

const CreateProduct = ({
	isPublished,
	close,
	closeNoRef,
	isDisable,
	item,
	initialVal = {
		name: "",
		description: "",
		price: "",
		type: optionsPurchase[0],
		totalNFTs: "1",
		category: "",
		image: "",
		endDate: "",
		startDate: "",
		tokenType: "ART_TOKEN",
		drawHtml: "",
		royalties: "",
		skuNumber: "",
		shippingInfo: {},
		auctionIncrementType: {
			value: 10,
			type: "RAW",
		},
		multiPrices: [],
		image_list: [],
		paymentType: "CARD_PAYMENT",
		period_time: "DAY",
	},
}) => {
	const { brand, locale } = useUser();
	const [isAuction, setAuction] = useState(initialVal.type === "Auction");
	const [criterias, setCriterias] = useState({
		w: true,
		lSize: true,
		girth: true,
	});
	const [isMint, setMint] = useState(false);
	const [local, setLocal] = useState({
		...initialVal,
		royalties:
			initialVal.royalties === ""
				? brand.royalty_percent
				: initialVal.royalties,
	});
	const { onOpen, onClose, isOpen } = UseDisclosure();
	const { isOpen: V, onOpen: createO, onClose: createC } = UseDisclosure();
	const {
		onOpen: onOpenConfirm,
		onClose: closeConfirm,
		isOpen: isOpenConfirm,
	} = UseDisclosure();

	const [{ isLoading }, upload] = UseApi({
		service: CreateNftTemplate,
	});

	const handleSubmit = (e) => {
		e.preventDefault();
		const img =
			typeof local?.image === "string"
				? local?.image
				: local?.image.core_image_url;
		if (isPublished) {
			if (!img) {
				ToastEmitter({
					type: "info",
					msg: "You should upload an image.",
				});
				return;
			}
			saveAfterPublish();
		} else {
			if (!img) {
				ToastEmitter({
					type: "info",
					msg: "You should upload an image.",
				});
			} else {
				onOpen();
			}
		}
	};

	const save = async (isDraft = true, isMint = false) => {
		const tmp = { ...local };
		// let nftCollection = tmp.nftCollection;

		const img = { ...tmp.image };
		if (!tmp.nftCollection || tmp.nftCollection === "hooson") {
			delete tmp.nftCollection;
		}
		if (img.image_list) {
			delete tmp.image;
			tmp.image = img.core_image_url;
			tmp.image_list = img.image_list;
		}
		if (isAuction) {
			tmp.type = options["Auction"];
		} else {
			tmp.type = options[tmp.type];
			delete tmp.auctionIncrementType;
		}
		if (tmp.type === "SINGLE_EDITION" || tmp.type === "AUCTION_EDITION") {
			tmp.totalNFTs = 1;
			if (tmp.type === "SINGLE_EDITION") delete tmp.endDate;
		}
		tmp.status = "OPEN";
		if (isDraft) {
			tmp.status = "DRAFT";
		} else if (tmp.startDate === "") {
			tmp.startDate = new Date();
		}
		if (isMint) {
			tmp.isMint = true;
		}
		tmp.multiPrices = tmp.multiPrices.filter(
			(obj) => Object.keys(obj).length !== 0
		);
		const res = await upload(tmp);
		if (res) {
			close(isDraft ? "Drafts" : "Published");
			ToastEmitter({
				type: "success",
				msg: "Your product published successfully",
			});
		}
	};

	const saveAfterPublish = async () => {
		if (item?.bids.length > local.totalNFTs) {
			ToastEmitter({
				msg: "Total nft count cannot be less than total sold count!",
				type: "info",
			});
			return;
		}
		const tmp = { ...local };
		if (!tmp.nftCollection || tmp.nftCollection === "hooson") {
			delete tmp.nftCollection;
		}
		const img = { ...tmp.image };
		if (isAuction) {
			tmp.type = options["Auction"];
		} else {
			tmp.type = options[tmp.type];
			delete tmp.auctionIncrementType;
		}
		if (tmp.type === "SINGLE_EDITION" || tmp.type === "AUCTION_EDITION")
			if (tmp.type === "SINGLE_EDITION") delete tmp.endDate;
		if (img.image_list) {
			delete tmp.image;
			tmp.image = img.core_image_url;
			tmp.image_list = img.image_list;
		}
		tmp.multiPrices = tmp.multiPrices.filter(
			(obj) => Object.keys(obj).length !== 0
		);
		const res = await upload(tmp);
		if (res) {
			close();
			ToastEmitter({
				type: "success",
				msg: "Your product saved successfully",
			});
		}
	};

	const draft = () => {
		if (local.name !== "") {
			save();
		} else {
			ToastEmitter({
				type: "info",
				msg: "Draft must have atleast name",
			});
		}
	};

	const setHtml = async (e) => {
		if (local._id) {
			const res = await upload({ _id: local._id, drawHtml: e });
			if (res) {
				ToastEmitter({
					type: "success",
					msg: "Html saved successfully",
				});
			}
		}
		setLocal((p) => {
			return { ...p, drawHtml: e };
		});
	};

	const datenow = new Date();
	return (
		<Card
			className={styles.card}
			title={product[locale][`${local._id ? "edit" : "create"}_prod`]}
			classTitle="title-green"
		>
			<form onSubmit={handleSubmit}>
				<Body
					isAuction={isAuction}
					setAuction={setAuction}
					isDisable={isDisable}
					item={item}
					createO={createO}
					local={local}
					setCriterias={setCriterias}
					criterias={criterias}
					setLocal={setLocal}
					isPublished={isPublished}
				/>
				<div className={styles.foot}>
					{isPublished ? (
						isDisable ? (
							<button
								onClick={closeNoRef}
								type="button"
								className="button"
							>
								{product[locale].close}
							</button>
						) : (
							<button
								// onClick={saveAfterPublish}
								// type="button"
								type="submit"
								className={cn("button", {
									disabled: isLoading,
								})}
							>
								{isLoading && <Loader />}
								{product[locale].save}
							</button>
						)
					) : (
						<>
							<button
								onClick={() => setMint(true)}
								type="submit"
								className={cn("button-stroke", {
									disabled: getIsValidPacakage(criterias),
								})}
							>
								{product[locale].mint}
							</button>
							<button
								onClick={draft}
								type="button"
								className={cn("button-stroke", {
									disabled:
										isLoading ||
										getIsValidPacakage(criterias),
								})}
							>
								{isLoading && <Loader />}
								{product[locale].save_draft}
							</button>
							<button
								type="submit"
								onClick={() => setMint(false)}
								className={cn("button", {
									disabled: getIsValidPacakage(criterias),
								})}
							>
								{product[locale].publish}
							</button>
						</>
					)}
				</div>
			</form>
			<Modal visible={isOpen} onClose={onClose}>
				<Confirm
					title={
						product[locale][
							isMint ? "publish_mint" : "publish_confirmation"
						]
					}
					onCancel={onClose}
					onConfirm={() => save(false, isMint)}
					isLoading={isLoading}
					note={isMint && product[locale].mint_note}
					buttonText={isMint && product[locale].proceed}
				>
					{local.startDate < datenow && local.startDate !== "" && (
						<div className={styles.warings}>
							Start date is earlier than now!
						</div>
					)}
					{local.type === "Standard" && local.endDate < datenow && (
						<div className={styles.warings}>
							End date is earlier than now!
						</div>
					)}
					{local.type === "Standard" &&
						local.endDate < local.startDate && (
							<div className={styles.warings}>
								End date is earlier than start date!
							</div>
						)}
				</Confirm>
			</Modal>
			<TemplateModal
				visible={V}
				onClose={isDisable ? createC : onOpenConfirm}
			>
				{V &&
					(isDisable ? (
						<RichViewer data={local.drawHtml} />
					) : (
						<RichEditor
							data={local.drawHtml}
							setData={setHtml}
							onClose={createC}
							closeConfirm={closeConfirm}
							isOpenConfirm={isOpenConfirm}
						/>
					))}
			</TemplateModal>
		</Card>
	);
};

export default CreateProduct;
